import axios from 'axios';

const Recursos = {
	namespaced : true,
	state : {
		monedas : [],
		tipoCuentas : []
	},
	actions : {
		getMonedas : async function({commit, state, rootState, rootGetters}){
			//let api = rootState.ApiTransferencias.monedas.all.endpoint;
			let api = rootGetters['ApiTransferencias/getMonedas'];

			const request = await axios.get(api).then((r) => {
				commit('setMonedas', r.data);
			});
		},
		getTipoCuentas : async function({commit, state, rootState, rootGetters}){
			//let api = rootState.ApiTransferencias.helpers.tipoCuenta.endpoint;
			let api = rootGetters['ApiTransferencias/getRecursoTipoCuentas'];

			const request = await axios.get(api).then((r) => {
				commit('setTipoCuentas', r.data);
			});
		}
	},
	mutations : {
		setMonedas : function(state, data){
			if(data.code == 200 && data.data.moneda.length > 0){
				state.monedas = data.data.moneda;
			}
		},
		setTipoCuentas : function(state, data){
			if(data.code == 200 && data.data.tipo_cuenta_bancaria.length > 0){
				state.tipoCuentas = data.data.tipo_cuenta_bancaria;
			}
		}
	}
};

export default Recursos;